import e,{keyframes as o}from"styled-components";import{theme as i}from"../../../theme.js";const r=o`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`,n=e.div`
  background-color: ${i.colors.gray[300]};
  border-radius: ${({variant:t})=>t==="circle"?"50%":i.radius+"px"};
  width: ${({width:t})=>t};
  height: ${({height:t})=>t};
  overflow: hidden;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: ${({width:t})=>t};
    top: 0;
    width: ${({width:t})=>t};
    height: ${({height:t})=>t};
    background: linear-gradient(to right, transparent 0%, #94A3B840 50%, transparent 100%);
    animation: ${r} 1s ease-in-out infinite;
  }
`;export{n as Container};
